import { alpha, Theme } from "@mui/material"

export function cellFieldFocusStyle(theme: Theme) {
    return {
        background: theme.palette.background.paper,
        // An outline, not a border: a border would shift the text by a pixel when the field gets focus.
        outline: `1px solid ${theme.palette.tailwind.blue[500]}`,
    }
}

/** Shared look of the inline cell editors: quiet until hovered, outlined while focused. */
export function cellFieldStyle(theme: Theme) {
    return {
        borderRadius: ".25rem",
        "&:hover": {
            background: alpha(theme.palette.common.black, 0.05),
        },
        "&.Mui-focused": cellFieldFocusStyle(theme),
    }
}

/** Amber hint on a mandatory field the kitchen started the dish without filling. */
export function cellFieldMissingStyle(theme: Theme) {
    return {
        outline: `1px dashed ${theme.palette.tailwind.amber[600]}`,
        // Only a hint of shade: the amber tint comes from the cell behind the field.
        background: alpha(theme.palette.common.black, 0.02),
    }
}
